import * as React from 'react';

import styles from './ai-homepage-text.module.css';

type Props = {
    text: string;
};

export function AiHomepageTitle(props: Props) {
    return <div className={styles.title}>{props.text}</div>;
}
